module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-classic-mode-mobile.d44e38f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/geotap-game-lucre-games-classic-mode-mobile.jpg
// module id = Hyvg
// module chunks = 0